/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

// Component imports
import { Col, Layout, Row, Typography } from 'antd';
import { HELVIA_WEBSITE_URL } from '../../constants/main';
import { useSelector } from 'react-redux';

// Constant declarations
const { Content } = Layout;

const AuthLayout = props => {
  const { isOidcAuthorizationCompletionInProgress } = useSelector(state => state.auth);

  return (
    <Layout className="min-h-100vh auth-layout">
      <Content style={{ minHeight: 280 }} className="d-flex justify-content-center align-items-center">
        <Row justify="center">
          <Col span={16}>
            {props.children}
          </Col>

          {!isOidcAuthorizationCompletionInProgress && (
            <Col xs={16}>
              <Row className="my-5 mx-11">
                <Col xs={24}>
                  <Typography.Text className="text-secondary">
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={`${HELVIA_WEBSITE_URL}tos`}
                      className="text-white"
                    >
                      {t('Terms of Service')}
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={`${HELVIA_WEBSITE_URL}privacy`}
                      className="text-white"
                    >
                      {t('Privacy Policy')}
                    </a>
                  </Typography.Text>
                </Col>

                <Col xs={24}>
                  <Typography.Text className="text-secondary">
                    {t('Copyright 2023. Helvia Technologies IKE')}
                  </Typography.Text>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Content>
    </Layout>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node
};

export default AuthLayout;
